<template>
  <header class="pages-header" :class="{ showSubNav }">
    <div class="pages-header__container">
      <a class="pages-header__logo" href="/">
        <img src="@/assets/common/header/logo_20230718.svg?v=20230718" alt="华秋电路logo" class="pcb-logo">
      </a>

      <nav class="pages-header__nav">
        <!-- 一级导航 -->
        <ul class="pages-header__nav__items">
          <li class="pages-header__nav__item home">
            <a href="/">
              首页
            </a>
          </li>

          <li class="pages-header__nav__item quote navActive">
            <a href="/quote">
              在线计价
              <i class="el-icon-arrow-down"></i>
            </a>
          </li>

          <li class="pages-header__nav__item">
            <a href="https://www.hqchip.com/" target="_blank" class="need_add_hqsource">
              元器件采购
            </a>
          </li>

          <li class="pages-header__nav__item">
            <a href="https://dfm.elecfans.com/?from=hqpcbdh" target="_blank" class="dfm_add_hqsource">
              DFM分析
            </a>
          </li>

          <li id="enginner" class="pages-header__nav__item enginner">
            <a href="javascript:void(0)" onclick="location.reload()" target="_blank">
              工程师服务
              <i class="el-icon-arrow-down el-icon"></i>
            </a>
            <!-- 下拉导航 -->
            <nav class="pages-header__dropdown">
              <i class="pages-header__dropdown__link"></i>
              <ul class="pages-header__dropdown__items">
                <li class="pages-header__dropdown__item elecfans">
                  <a href="https://www.elecfans.com" target="_blank">
                    电子发烧友
                  </a>
                </li>
                <li id="enginner" class="pages-header__dropdown__item bbs">
                  <a href="http://bbs.elecfans.com" target="_blank">
                    社区交流
                  </a>
                </li>
                
                <li id="enginner" class="pages-header__dropdown__item t-elecfans">
                  <a href="http://t.elecfans.com" target="_blank">
                    工程师学院
                  </a>
                </li>

                <li id="enginner" class="pages-header__dropdown__item t-elecfans">
                  <a href="https://webinar.elecfans.com/" target="_blank">
                    工程师研讨会
                  </a>
                </li>

                
                <li id="enginner" class="pages-header__dropdown__item yingsheng">
                  <a  href="https://yingsheng.elecfans.com/app" target="_blank">
                    硬声短视频
                  </a>
                </li>
                <li id="enginner" class="pages-header__dropdown__item pdf-elecfans">
                  <a href="https://pdf.elecfans.com" target="_blank">
                    Datasheet
                  </a>
                </li>
              </ul>
            </nav>
          </li>

          <li class="pages-header__nav__item about">
            <a href="https://www.huaqiu.com/about/groupoverview" target="_blank">
              关于华秋
              <i class="el-icon-arrow-down el-icon"></i>
            </a>
            <!-- 下拉导航 -->
            <nav class="pages-header__dropdown">
              <i class="pages-header__dropdown__link"></i>
              <ul class="pages-header__dropdown__items">
                <li class="pages-header__dropdown__item">
                  <a href="https://www.huaqiu.com/about/groupoverview" target="_blank">
                    华秋简介
                  </a>
                </li>
                <li class="pages-header__dropdown__item">
                  <a href="http://www.huaqiu.cn/about/corporateculture" target="_blank">
                    企业文化
                  </a>
                </li>
                <li class="pages-header__dropdown__item">
                  <a href="https://www.huaqiu.com/about/developmenthistory" target="_blank">
                    发展历程
                  </a>
                </li>
                <li class="pages-header__dropdown__item">
                  <a href="https://www.huaqiu.com/about/ceospeech" target="_blank">
                    CEO致辞
                  </a>
                </li>
                <li class="pages-header__dropdown__item">
                  <a href="http://www.huaqiu.cn/jobs" target="_blank">
                    加入我们
                  </a>
                </li>
                <li class="pages-header__dropdown__item">
                  <a href="https://www.huaqiu.com/about/contactus" target="_blank">
                    联系我们
                  </a>
                </li>
              </ul>
            </nav>
          </li>
        </ul>

        <!-- 在线计价 二级导航 -->
        <nav class="pages-header__subNav pages-header__subNav__quote">
          <ul class="pages-header__subNav__items">
            <li class="pages-header__subNav__item smt" :class="{ subNavActive }">
              <a href="/quote">
                SMT计价
              </a>
              <span class="pages-header__nav_badge down-price"></span>
            </li>
            <li class="pages-header__subNav__item pcb">
              <a href="https://www.hqpcb.com/quote.html" class="need_add_hqsource">
                PCB计价
              </a>
            </li>
            <li class="pages-header__subNav__item hdi">
              <a href="https://www.hqpcb.com/quote?hdi=1" class="need_add_hqsource">
                HDI板计价
              </a>
              <span class="pages-header__nav_badge new-badge"></span>
            </li>
            
            <li class="pages-header__subNav__item fpc">
              <a href="https://www.hqpcb.com/quote/fpc.html" class="need_add_hqsource">
                FPC计价
              </a>
            </li>
            <li class="pages-header__subNav__item layout">
              <a href="https://www.hqpcb.com/LayoutOrder/index" class="need_add_hqsource">
                Layout计价
              </a>
            </li>
            
            <li class="pages-header__subNav__item stencli">
              <a href="https://www.hqpcb.com/stencil/quote.html" class="need_add_hqsource">
                钢网计价
              </a>
            </li>
            
            <li class="pages-header__subNav__item bom">
              <a href="https://www.hqchip.com/bom.html" class="need_add_hqsource">
                BOM配单
              </a>
            </li>
          </ul>
        </nav>

        <!-- 制造能力 二级导航 -->
        <!-- <nav class="pages-header__subNav pages-header__subNav__capacity">
          <ul class="pages-header__subNav__items">
            <li id="capacity" class="pages-header__subNav__item sub-hqpcb">
              <a href="/ability.html">
                PCB定制
              </a>
            </li>
            
            <li id="capacity" class="pages-header__subNav__item sub-smt">
              <a href="/hqsmt.html">
                SMT贴片
              </a>
            </li>
            
            <li id="capacity" class="pages-header__subNav__item sub-layout">
              <a href="/hqpcblayout.html">
                PCB layout
              </a>
            </li>
            
            <li id="capacity" class="pages-header__subNav__item sub-stencil">
              <a  href="/hqstencil.html">
                钢网制造
              </a>
            </li>
            
            <li id="capacity" class="pages-header__subNav__item sub-factory">
              <a href="/factory.html">
                设备展示
              </a>
            </li>

            <li id="capacity" class="pages-header__subNav__item sub-product">
              <a href="/product.html">
                产品展示
              </a>
            </li>

            <li id="capacity" class="pages-header__subNav__item sub-vrlook">
              <a href="/vr.html" target="_blank">
                VR看厂
              </a>
            </li>

            <li id="capacity" class="pages-header__subNav__item sub-impedance">
              <a href="/quote/impedance" target="_blank">
                阻抗叠层试算
              </a>
            </li>
          </ul>
        </nav> -->
      </nav>
    </div>
  </header>
</template>
<script>
export default {
  data() {
    return {
      showSubNav: true,
      subNavActive: true
    }
  }
}
</script>
<style lang="scss" scoped>
// 导航栏
$headerColor: #B60005;
$headerbadgeColor: #05A960;
$headerBgColor: #F8F8F8;
$headerNavHeight: 50px;
$headerZindex: 1000;

// 激活状态
.navActive {
  // 一级导航
  &.pages-header__nav__item {
    >a {
      color: $headerColor;
      &::after {
        visibility: visible !important;
      }
    }
    &.hide-dropdown:hover {
      .el-icon {
        transform: rotate(0deg) !important;
      }
      .pages-header__dropdown {
        visibility: hidden !important;
      }
    }
  }
}
.subNavActive {
  // 二级导航
  &.pages-header__subNav__item,
  // 下拉导航
  &.pages-header__dropdown__item {
    >a {
      font-weight: 700;
      color: $headerColor;
    }
  }
  // 二级导航
  &.pages-header__subNav__item {
    background-color: #f2f3f5;
  }
}

// 在线计价 - 二级导航常态显示
.pages-header.showSubNav {
  margin-bottom: 49px;
  .pages-header__subNav.pages-header__subNav__quote {
    visibility: visible;
  }
}

.pages-header {
  position: relative;
  z-index: $headerZindex;
  height: 80px;
  font-size: 13px;
  border-bottom: 1px solid #e6e6e6;
  background-color: $headerBgColor;
  a {
    line-height: 1;
    color: #333;
    &:hover {
      color: $headerColor;
    }
  }
  .pages-header__container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    width: 1200px;
    height: 80px;
  }

  .pages-header__logo {
    display: block;
    margin-right: 130px;
    width: 192px;
    >img {
      display: block;
      height: $headerNavHeight;
    }
  }

  .pages-header__nav_badge {
    display: block;
    width: 0;
    height: 0;
    line-height: 1;
    position: absolute;
    z-index: $headerZindex + 3;
    &::after {
      display: inline-block;
      padding: 2px 4px;
      white-space: nowrap;
      font-size: 12px;
      font-weight: 400;
      border-radius: 4px;
    }
    &.new-badge {
      top: 8px;
      left: 81px;
      &::after {
        content: 'new';
        padding: 1px 4px 3px;
        color: #fff;
        background-color: $headerbadgeColor;
      }
    }
    &.down-price {
      top: 8px;
      left: 73px;
      &::after {
        content: '降价';
        color: #fff;
        background-color: #e6a23c;
      }
    }
  }

  // 一级导航
  .pages-header__nav {
      .pages-header__nav__items {
          display: flex;
          justify-content: center;
          align-items: center;
          height: $headerNavHeight;
      }
      .pages-header__nav__item {
          position: relative;
          display: flex;
          align-items: center;
          margin-right: 3px;
          padding: 0 15px;
          height: 100%;
          color: #f2f2f2;
          font-weight: 700;
          border-radius: 5px;
          // 用于鼠标移入下拉导航过渡
          &::after {
              content: '';
              position: absolute;
              bottom: -4px;
              left: 0;
              display: block;
              width: 100%;
              height: 4px;
          }
          &:hover {
              background-color: #fff;
              .hdi-badge {
                  opacity: 0;
              }
              .el-icon {
                  transform: rotate(180deg);
              }
              .pages-header__dropdown {
                  visibility: visible;
              }
          }
          >a {
              position: relative;
              display: block;
              padding: 0 3px;
              line-height: 50px;
              font-size: 15px;
              letter-spacing: 0.6px;
              &::after {
                  content: '';
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 4px;
                  border-radius: 4px;
                  background-color: $headerColor;
                  visibility: hidden;
              }
          }
          .el-icon {
              font-size: 12px;
              transition-duration: .3s;
          }

          &.quote {
              .pages-header__dropdown {
                  width: 168px;
              }
          }
      }
  }

  // 二级导航
  .pages-header__subNav {
      position: absolute;
      left: 0px;
      right: 0px;
      bottom: -50px;
      z-index: $headerZindex + 5;
      height: 48px;
      border-bottom: 1px solid #e6e6e6;
      background-color: #FFFFFF;
      visibility: hidden;
      transition-duration: .15s;
      .pages-header__nav_badge {
          top: -2px;
          right: 0;
      }
      .pages-header__subNav__items {
          margin: 0 auto;
          width: 1200px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
      }
      .pages-header__subNav__item {
          position: relative;
          margin: 0 1px;
          color: #333333;
          border-radius: 4px;
          &:hover {
              color: $headerColor;
              background-color: #f2f3f5;
          }
          >a {
              display: block;
              padding: 0 18px;
              height: 32px;
              line-height: 32px;
          }
      }
  }

  // 下拉导航
  .pages-header__dropdown {
      position: absolute;
      top: 54px;
      left: 0;
      z-index: $headerZindex + 10;
      width: 140px;
      border: 1px solid #555;
      border-radius: 4px;
      background-color: #fff;
      transition-delay: .15s;
      visibility: hidden;
      // 连线图标
      .pages-header__dropdown__link {
          position: absolute;
          left: 5px;
          top: -10px;
          width: 0;
          height: 16px;
          border-left: 1px solid #e0e0e0;
          &::before,
          &::after {
              content: '';
              position: absolute;
              left: -3px;
              z-index: $headerZindex + 2;
              display: block;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              border: 1px solid #d7d7d7;
          }
          &::before {
              top: -4px;
          }
          &::after {
              bottom: -4px;
          }
      }
      .pages-header__dropdown__items {
          padding: 5px 0;
          box-shadow: 3px 4px 5px rgba(51, 51, 51, 0.4);
      }
      .pages-header__dropdown__item {
          position: relative;
          color: #333;
          font-weight: 400;
          :hover {
              background-color: #f5f7fa;
          }
          >a {
              display: block;
              padding-left: 10px;
              line-height: 32px;
              text-align: left;
          }
      }
  }
}
</style>